import { render } from "./Category.vue?vue&type=template&id=c25e3c40"
import script from "./Category.vue?vue&type=script&lang=js"
export * from "./Category.vue?vue&type=script&lang=js"

import "./Category.vue?vue&type=style&index=0&id=c25e3c40&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/settings/Category.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c25e3c40"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c25e3c40', __exports__)) {
    api.reload('c25e3c40', __exports__)
  }
  
  module.hot.accept("./Category.vue?vue&type=template&id=c25e3c40", () => {
    api.rerender('c25e3c40', render)
  })

}


export default __exports__